<template>
  <h1>{{ $t('menu.pim.subpages.productsFilter.header')}} ({{ this.hotSettings.data.length }})</h1>
  <div class="pb-4">
    <button class="appButton mt-2" @click="this.$router.push('/pim')">{{ $t('menu.pim.subpages.productsFilter.back')
      }}</button>
    <button class="appButton mt-2" @click="refresh()">{{ $t('menu.pim.subpages.productsFilter.refresh')
      }}</button>
  </div>
  <div
    v-for="bar in statusBars"
    :key="bar.key"
    class="mb-4 rounded-md"
    :style="bar.rows.length === 0
      ? 'background: #142218; border: 1px solid rgba(74,222,128,0.3);'
      : 'background: #2a2410; border: 1px solid rgba(250,204,21,0.3);'"
  >
    <div
      class="p-3 flex items-center cursor-pointer select-none"
      @click="expanded[bar.key] = !expanded[bar.key]"
    >
      <span class="mr-2">{{ expanded[bar.key] ? '▼' : '▶' }}</span>
      <span>{{ $t(bar.label) }}:</span>
      <span class="ml-2 font-semibold" :class="bar.rows.length === 0 ? 'text-green-400' : 'text-yellow-400'">
        {{ bar.rows.length }}
      </span>
    </div>
    <div v-if="expanded[bar.key] && bar.rows.length > 0" class="px-3 pb-3">
      <table class="w-full text-sm">
        <thead>
          <tr class="text-left" style="border-bottom: 1px solid rgba(255,255,255,0.1);">
            <th class="py-2 pr-4">SKU</th>
            <th class="py-2 pr-4">Title</th>
            <th class="py-2 pr-4">Status</th>
            <th class="py-2 pr-4">{{ bar.valueHeader }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in bar.rows" :key="row[0]" style="border-bottom: 1px solid rgba(255,255,255,0.05);">
            <td class="py-1 pr-4">{{ row[1] }}</td>
            <td class="py-1 pr-4">{{ row[2] }}</td>
            <td class="py-1 pr-4">{{ row[3] }}</td>
            <td class="py-1 pr-4">{{ row[bar.valueIndex] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="flex">
    <div class="w-full">
      <hot-table :settings="hotSettings"></hot-table>
    </div>
  </div>

</template>

<script>
import { useSettings } from '@/store/user'
import mixins from '@/components/mixins';
import { HotTable } from '@handsontable/vue3';
import { registerAllModules } from 'handsontable/registry';
import 'handsontable/dist/handsontable.full.css';

// register Handsontable's modules
registerAllModules();

export default {
    mixins: [mixins],
    setup() {
        const user = useSettings();

        return { user }
    },
    created() {
      this.hotSettings.data = this.user.pim.products.map(product => {
        return [product.id, product.sku, product.title, product.status, product.product_subtype, product.colour_category, product.is_it_a_set, product.video_1, product.sds, product.internal_comment, product.safety];
      });
    },
    components: {
      HotTable,
    },
    computed: {
      activeRowsMissing() {
        const isEmpty = v => v === null || v === undefined || v.toString().trim() === '';
        const rows = this.hotSettings.data.filter(r => (r[3] || '').toString().toUpperCase() === 'ACTIVE');
        return {
          subtype: rows.filter(r => isEmpty(r[4])),
          color: rows.filter(r => isEmpty(r[5])),
          setType: rows.filter(r => isEmpty(r[6])),
          video: rows.filter(r => isEmpty(r[7])),
          sds: rows.filter(r => isEmpty(r[8])),
        };
      },
      statusBars() {
        const m = this.activeRowsMissing;
        return [
          { key: 'subtype', label: 'menu.pim.subpages.productsFilter.missingSubtype', rows: m.subtype, valueIndex: 4, valueHeader: 'Product Subtype' },
          { key: 'color', label: 'menu.pim.subpages.productsFilter.missingColor', rows: m.color, valueIndex: 5, valueHeader: 'Color' },
          { key: 'setType', label: 'menu.pim.subpages.productsFilter.missingSetType', rows: m.setType, valueIndex: 6, valueHeader: 'Is it a Set' },
          { key: 'video', label: 'menu.pim.subpages.productsFilter.missingVideo', rows: m.video, valueIndex: 7, valueHeader: 'Video 1' },
          { key: 'sds', label: 'menu.pim.subpages.productsFilter.missingSds', rows: m.sds, valueIndex: 8, valueHeader: 'SDS' },
        ];
      }
    },
    data() {
      return {
        expanded: {
          subtype: false,
          color: false,
          setType: false,
          video: false,
          sds: false,
        },
        hotSettings: {
          data: [],
          height: 'auto',
          filters: false,
          dropdownMenu: false,
        //   hiddenColumns: {
        //     columns: [0],
        //     indicators: true
        //   },
          manualRowMove: false,
          autoWrapRow: true,
          autoWrapCol: true,
          fillHandle: true,
          rowHeaders: true,
          colHeaders: ['ID', 'SKU', 'Title', 'Status', 'Product Subtype', 'Color', 'Is it a Set', 'Video 1', 'SDS', 'Comment'],
          columns: [
            { data: 0, name: 'id', type: 'numeric', editor: false},
            { data: 1, name: 'sku', type: 'text', editor: false},
            { data: 2, name: 'title', type: 'text', editor: false},
            { data: 3, name: 'status', type: 'text', editor: false},
            { data: 4, name: 'product_subtype', namespace: 'custom', field_type: 'single_line_text_field', type: 'text'},
            { data: 5, name: 'colour_category', namespace: 'custom', field_type: 'list.single_line_text_field', type: 'text'},
            { data: 6, name: 'is_it_a_set_', namespace: 'custom', field_type: 'list.single_line_text_field', type: 'text'},
            { data: 7, name: 'video_1', namespace: 'custom', field_type: 'url', type: 'text'},
            { data: 8, name: 'sds_type', namespace: 'custom', field_type: 'metaobject_reference', type: 'text'},
            { data: 9, name: 'internal_comment', namespace: 'custom', field_type: 'single_line_text_field', type: 'text'}
          ],
          // licenseKey: '53013-4578b-9e935-c450e-92257',
          licenseKey: 'non-commercial-and-evaluation',
          afterChange: (changes) => {
            changes?.forEach(([row, prop, oldValue, newValue]) => {
              
              // extract the Shopify ID from the product ID
              const match = this.user.pim.products[row].id.match(/gid:\/\/shopify\/Product\/(\d+)/);
              const Shopify_id = match ? match[1] : null;

              const field = this.hotSettings.columns[prop].name;
              const field_type = this.hotSettings.columns[prop].field_type || 'single_line_text_field';
              const namespace = this.hotSettings.columns[prop].namespace || 'custom';

              const obj = {
                productId: Shopify_id,
                metafield: field,
                value: newValue,
                type: field_type,
                namespace: namespace
              };
              
              this.user.updateProductPim(obj);
            });
          }
        },
      };
    },
    methods: {
       refresh() {
        this.hotSettings.data = [];
        this.user.getProductsPim().then(() => {
           this.hotSettings.data = this.user.pim.products.map(product => {
             return [product.id, product.sku, product.title, product.status, product.product_subtype, product.colour_category, product.is_it_a_set, product.video_1, product.sds, product.internal_comment, product.safety];
           });
         });
      }       
    }
};

</script>